import { render, staticRenderFns } from "./TabsList.vue?vue&type=template&id=7f8a3972&scoped=true&"
import script from "./TabsList.vue?vue&type=script&lang=js&"
export * from "./TabsList.vue?vue&type=script&lang=js&"
import style0 from "./TabsList.vue?vue&type=style&index=0&id=7f8a3972&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8a3972",
  null
  
)

export default component.exports